<div #printContent id="printContent">
  <wf-page-tour [steps]="tourSteps"></wf-page-tour>
  <div class="print-hide" *ngIf="showSchoolFilter">
    <wf-school-teacher-filter
      [error]="schoolFilterError"
      [districts]="districts"
      [schools]="schools"
      [teachers]="teachers"
      (filterChangeEvent)="updateTeacherStudents()"
    ></wf-school-teacher-filter>
  </div>
  <div  [ngClass]="{ 'disabled-report' : schoolFilterError }"></div>
  <div class="header-controls split-flex">
    <h3>
      <fa-icon [icon]="reportsIcon"/>
      Reports
    </h3>
    <div class="flex-row-align">
      <div id="hideSharedStudentsCheckBox" class="print-hide margin-top-5" *ngIf="this.showCoTeacherFilter">
        <input class="margin-left-5" id="coteacher-checkbox" type="checkbox" [(ngModel)]="hideSharedStudents" (change)="toggleSharedStudents()" />
        <label class="margin-left-5" for="coteacher-checkbox">Hide shared students</label>
      </div>
      <button id="print-button" class="btn print-summary-button print-hide" (click)="printSummary()" *ngIf="!currentUser!.isTeacherReviewUser()"><fa-icon [icon]="printIcon"></fa-icon> Print Results</button>
      <button id="batch-print-button" class="btn print-summary-button print-hide" (click)="openBatchPrintDialog()" *ngIf="!currentUser!.isTeacherReviewUser()"><fa-icon [icon]="batchPrintIcon"></fa-icon> Batch Print</button>
    </div>
  </div>
  <div class="report-section-header">
    <h5 class="results-report-header"><fa-icon [classes]="['print-hide']" [icon]="studentIcon"></fa-icon> Student Summary</h5>
  </div>
  <div class="report-container">
    <div class="report-row flex split-flex" style="align-items: flex-end ;">
      <div class="width-25">
        <label for="student-dropdown">Student</label>
        <select id="student-dropdown" class="form-select print-hide" [(ngModel)]="selectedStudent" (change)="updateStudentSummaryData()">
          <option *ngFor="let student of currentStudents; trackBy: trackByStudentId" [ngValue]="student">{{ student.firstName }} {{ student.lastName }}</option>
        </select>
        <div class="print-show">{{selectedStudent?.firstName || ''}} {{selectedStudent?.lastName || ''}}</div>
      </div>
      <div class="large-label">
        Report Generated: {{ currentDate }}
      </div>
    </div>
    <div class="report-row">
      <div id="student-usage-progress-wrapper" class="report-column width-100 print-flex-100 page-break-after">
        <div class="report-panel">
          <div class="title">Usage and Progress</div>
          <div class="section-description">This section shows how your student is progressing through WordFlight.</div>
          <div class="content">
            <div class="report-row" style="align-items: flex-start;">
              <div class="report-column" style="flex: 1;">
                <div class="flex" style="gap: 8px;">
                  <div class="usage-info-row usage-unit-row" style="flex: 1; margin-bottom: 0;">
                    <div class="usage-info-label">
                      <div class="bold">Current Unit</div>
                      <div class="section-description-small">Students work through {{ totalUnits }} units. A good goal is to complete 1 unit each week.</div>
                    </div>
                    <div class="usage-info-stat center-text">
                      <div class="stat usage-info-stat-box">
                        <div class="stat-value">{{ currentUnit }}</div>
                        <div class="stat-label">out of {{ totalUnits }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="usage-info-row usage-unit-row" style="flex: 1; margin-bottom: 0;">
                    <div class="usage-info-label">
                      <div class="bold">Current Level</div>
                      <div class="section-description-small">There are 5 Levels per unit for a total of {{ totalLevels }} levels.</div>
                    </div>
                    <div class="usage-info-stat center-text">
                      <div class="stat usage-info-stat-box">
                        <div class="stat-value">{{ currentLevel }}</div>
                        <div class="stat-label">out of {{ totalLevels }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="usage-info-row usage-bar-row">
                  <div class="usage-info-label">
                    <div class="bold">Minutes This Week</div>
                    <div class="section-description-small">Shows how many minutes your student practiced this week. The goal is {{ minWeeklyTimeGoal }}+ minutes per week.</div>
                  </div>
                  <div class="usage-info-stat">
                    <div class="flex center-flex column-gap-10">
                      <div class="usage-bar-stat-mini center-text">
                        <div class="usage-bar-stat-value">{{ minutesThisWeek | number: '1.0-0' }}<span class="usage-goal-unit">min</span></div>
                        <div class="section-description-small">out of {{ minWeeklyTimeGoal }}</div>
                      </div>
                      <div style="flex: 1; display: flex; flex-direction: column; gap: 4px;">
                        <div class="horizontal-gauge">
                          <div class="filled-gauge" [ngStyle]="{ 'background': 'linear-gradient(to right, #0095DA 0% ' + minutesWeekPercent + '%, #E5E5E5 ' + minutesWeekPercent + '% 100%)' }"></div>
                        </div>
                        <div class="small-instruction">Minimum Weekly Time Goal ({{ minWeeklyTimeGoal }} Minutes)</div>
                      </div>
                      <div>
                        <fa-icon class="print-icon" [classes]="['fa-2x', 'warn-color']" [icon]="warningIcon" *ngIf="minutesThisWeek < minWeeklyTimeGoal"></fa-icon>
                        <fa-icon class="print-icon" [classes]="['fa-2x']" style="color: #58B957" [icon]="checkIcon" *ngIf="minutesThisWeek >= minWeeklyTimeGoal"></fa-icon>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="usage-info-row usage-bar-row">
                  <div class="usage-info-label">
                    <div class="bold">Levels This Week</div>
                    <div class="section-description-small">Shows how many levels your student completed this week. The goal is {{ minWeeklyLevelsGoal }} or more levels each week.</div>
                  </div>
                  <div class="usage-info-stat">
                    <div class="flex center-flex column-gap-10">
                      <div class="usage-bar-stat-mini center-text">
                        <div class="usage-bar-stat-value">{{ levelsThisWeek }}<span class="usage-goal-unit">levels</span></div>
                        <div class="section-description-small">out of {{ minWeeklyLevelsGoal }}</div>
                      </div>
                      <div style="flex: 1; display: flex; flex-direction: column; gap: 4px;">
                        <div class="horizontal-gauge">
                          <div class="filled-gauge" [ngStyle]="{ 'background': 'linear-gradient(to right, #0095DA 0% ' + levelsWeekPercent + '%, #E5E5E5 ' + levelsWeekPercent + '% 100%)' }"></div>
                        </div>
                        <div class="small-instruction">Minimum Levels per Week ({{ minWeeklyLevelsGoal }} Levels)</div>
                      </div>
                      <div>
                        <fa-icon class="print-icon" [classes]="['fa-2x', 'warn-color']" [icon]="warningIcon" *ngIf="levelsThisWeek < minWeeklyLevelsGoal"></fa-icon>
                        <fa-icon class="print-icon" [classes]="['fa-2x']" style="color: #58B957" [icon]="checkIcon" *ngIf="levelsThisWeek >= minWeeklyLevelsGoal"></fa-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="report-column padding-15" style="width: 260px; flex-shrink: 0;">
                <wf-usage-goal-panel [minWeeklyTimeGoal]="minWeeklyTimeGoal" [avgWeeklyUsage]="avgWeeklyUsage"></wf-usage-goal-panel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="report-row">
      <div id="student-performance-wrapper" class="report-column width-100">
        <div class="report-panel">
          <div class="title">Performance</div>
          <div class="section-description">This section shows your student's growth and learning progress in WordFlight.</div>
          <div class="content">
            <div class="report-row print-flex-column">
              <div id="screenerResults" class="report-column width-35 print-flex-100 performance-panel panel-padding">
                <div class="section-title">Screener Results</div>
                <div class="section-description-small">The WordFlight Screener helps predict how a student may perform on the Diagnostic and whether WordFlight is a good fit for them. Results include a score range, risk category, and test date. The goal is for students to grow toward the green Proficiency range.</div>
                <div class="report-row center-flex">
                  <div class="report-column width-50 panel-padding row-gap-0">
                    <div class="legend-green"><div class="pie-legend">Proficient</div></div>
                    <div class="legend-yellow"><div class="pie-legend">Some Risk</div></div>
                    <div class="legend-red"><div class="pie-legend">High Risk</div></div>
                  </div>
                  <div class="report-column width-50 row-gap-5 center-text padding-15 bg-light-gray">
                    <div class="bold dark-gray">Results</div>
                    <div class="screener-results-score" [ngClass]="screenerClass"> {{ screenerRange }} </div>
                    <div class="bold margin-top-15 dark-gray">Date Completed</div>
                    <div>{{ screenerDate }}</div>
                  </div>
                </div>
              </div>
              <div id="diagnosticResults" class="report-column width-65 print-flex-100 performance-panel panel-padding">
                <div class="section-title flex split-flex">
                  <div>
                    Diagnostic Results
                  </div>
                  <div>
                    <button id="diagnostic-button" class="btn action-button print-hide" (click)="goToDiagnosticDetails()">
                      <fa-icon [icon]="diagnosticIcon"></fa-icon> Student Diagnostic Detail Report
                    </button>
                  </div>
                </div>
                <div class="section-description-small">Students take the Diagnostic before unit 1, after unit 12, and after unit 24. Students in grades 5+ receive both Automatic Word Recognition and Decoding scores. Students in grades 2–4 receive a Word Recognition score. The goal is continued growth toward strong, automatic word recognition skills.</div>
                <div class="report-row margin-top-15">
                  <table class="center-text flex-grow-1">
                    <thead>
                      <tr>
                        <th>Word Recognition</th>
                        <th>Decoding</th>
                        <th>Test Type</th>
                        <th>Date Completed</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let diagnostic of diagnostics">
                        <td class="padding-top-5 padding-bottom-5"><div [ngClass]="diagnostic.recognitionClass">{{ diagnostic.recognition }}</div></td>
                        <td class="padding-top-5 padding-bottom-5"><div [ngClass]="diagnostic.decodingClass">{{ diagnostic.decoding }}</div></td>
                        <td class="padding-top-5 padding-bottom-5">{{ diagnostic.title }}</td>
                        <td class="padding-top-5 padding-bottom-5">{{ diagnostic.completed }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="report-row">
              <div class="report-column width-100">
                <div id="objectiveResults" class="performance-panel panel-padding">
                  <div class="section-title flex split-flex">
                    <div>
                      Objective Pre/Post Results
                    </div>
                    <div>
                      <button id="assessments-button" class="btn action-button print-hide" (click)="goToObjectiveDetails()">
                        <fa-icon [icon]="objectiveIcon"></fa-icon> Objective Pre/Post Report
                      </button>
                    </div>
                  </div>
                  <div class="section-description-small">Students take a short pretest before each of the six learning objectives. Students then practice skills each day to build growth and confidence in decoding, syllable knowledge and word recognition. After students complete four units in the learning objective, they take the short posttest.</div>
                  <div class="report-row margin-top-25 center-space-flex">
                    <div class="report-column width-75">
                      <div class="objective-assessments-charts-container">
                        <div class="print-hide">
                          <canvas #objectiveChartCanvas
                                  id="objective-assessments-chart"
                                  baseChart
                                  [data]="objectiveChartData()"
                                  [type]="chartType"
                                  [plugins]="chartPlugins"
                                  [options]="chartOpts"></canvas>
                        </div>
                        <img #objectiveChartImg id="cumulative-objective-chart-img" class="chart-img print-flex-100" />
                      </div>
                    </div>
                    <div class="report-column width-10">
                      <div class="objective-assessments-chart-legend">
                        <div><div class="legend-box pretest-objective-growth"></div><div class="legend-label">Pretest</div></div>
                        <div><div class="legend-box posttest-objective-growth"></div><div class="legend-label">Posttest</div></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<wf-batch-print-dialog
  [isOpen]="showBatchPrintDialog()"
  printType="student-summary"
  [students]="currentStudents"
  [isGenerating]="isGeneratingBatchPrint()"
  (onClose)="closeBatchPrintDialog()"
  (onPrint)="batchPrint($event)">
</wf-batch-print-dialog>

<wf-pdf-preview
  [isOpen]="showPdfPreview()"
  [pdfUrl]="batchPdfUrl()"
  fileName="student-summary.pdf"
  (onClose)="closeBatchPdfPreview()">
</wf-pdf-preview>
